<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" :title="title">
          <div slot="content">
            <div class="form-group col-md-12 col-sm-12 col-xs-12">
              <label>Mã</label>
              <input type="text" class="form-control" v-model="param.key" placeholder="Nhập tên gói..." disabled/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorValue ? 'has-error' : ''">
              <label>Giá trị<span class="error-symbol"></span></label>
              <input type="text" class="form-control" v-model="param.value" placeholder="Nhập giá ..."/>
            </div>
          </div>
          <div slot="footer">
            <div class="pull-right">
              <b-button variant="success" class="w-100px" @click="save">Lưu</b-button>
              <b-button variant="warning" class="w-100px" @click="back">Trờ về</b-button>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import ParamAPI from '../../../api/param'
import Utils from '../../../common/utils'

export default {
  name: 'ParamDetail',
  components: {
    'va-box': VABox,
  },
  data () {
    return {
      param: {
        id: null,
        key: '',
        value: ''
      },
      loading: false,
      click: false,
      saving: false,
      title: ''
    }
  },
  computed: {
    errorValue: function () {
      return this.isEmpty(this.param.value)
    },
  },
  mounted () {
    this.init()
    this.title = this.isEdit() ? 'Cập nhật tham số' : 'Thêm tham số mới'
  },
  methods: {
    isEdit () {
      return !!this.$route.params.id
    },
    validate () {
      return !this.errorValue
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    init () {
      this.getParamDetail()
    },
    async getParamDetail () {
      this.loading = true
      const id = this.$route.params.id
      if (id) {
        try {
          this.param = (await ParamAPI.findById(id)).data.data
          this.loading = false
        } catch (err) {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        }
      }
      return null
    },
    back () {
      this.$router.push({name: 'ParamList'})
    },
    save () {
      this.click = true
      this.saving = true
      this.loading = true
      const id = this.$route.params.id
      if (!this.validate()) {
        this.saving = false
        this.loading = false
        return
      }
      if (id) {
        ParamAPI.update(this.param).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        ParamAPI.create(this.param).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.back()
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/param/ParamDetail.vue